import React, { useEffect, useState } from "react";
import { Container, Box, useMediaQuery, Grid } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import {
  fLoadTripsByDateRange,
  fUpdateTripPostingStatus,
} from "./EasyLoadingAction";
import {
  CmpButton,
  CmpDatePicker,
} from "../../Component/Common/ToolBox/ToolBox";
import moment from "moment";
import EasyLoading_Breadcrumbs from "./EasyLoading_BreadCrumbs";
import { useSelector } from "react-redux";
import { ReportRemoveSequenceChar, ReportUrl } from "../../Utility/Utilitys";
import GCWebReport from "../../Component/Common/ReuseableComponent/GCWebReport";

const TripDetailSummary = () => {
  const [Summary, setSummary] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
 
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");

  const GetReportsView = async (TripID, trntyp) => {
    console.log(
      "sCurrentReport----",
      vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val + "WMS/Trip?" + "trntyp=" + trntyp + "&TripID=" + TripID
    );
    setWebReportUrlModal(
      `${vRdxDBKernObj?.WEB_REPORT_BASE_URL?.Val}WMS/Trip?trntyp=${trntyp}&TripID=${TripID}`
    );

    setWebReportModal(true);
  };

  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const [rows, setRows] = useState([
    // {
    //     id:1,
    //   TripID: 4,
    //   TruckID: "002",
    //   Status: "ENTER",
    //   EnBy: "001",
    //   EnDt: "2024-08-08T10:55:28.370Z",
    //   PostBy: null,
    //   PostDt: null,
    //   truckName: "D 47154 DXB",
    // },
  ]);

  const [columns, setcolumns] = useState([
    {
      field: "closeTrip",
      headerName: "Close Trip",
      align: "center",
      headerAlign: "center",
      width: 110,
      renderCell: (params) => (
        <CmpButton
          xbtnName="Close Trip"
          xOnClick={() => update(params.row.TripID, "TRIPCONS")}
          xVariant="contained"
          xDisabled={params.row.Status !== "ENTER"}
          xSize="small"
        />
      ),
    },
    {
      field: "Summary",
      headerName: "Summary",
      align: "center",
      headerAlign: "center",
      width: 110,
      renderCell: (params) => (
        <CmpButton
          xbtnName="Summary"
          xOnClick={() => GetReportsView(params.row.TripID, "TRIPCONS")}
          xVariant="contained"
          xDisabled={false}
          xSize="small"
        />
      ),
    },
    {
      field: "Detail",
      headerName: "Detail",
      align: "center",
      headerAlign: "center",
      width: 110,
      renderCell: (params) => (
        <CmpButton
          xbtnName="Detail"
          xOnClick={() => GetReportsView(params.row.TripID, "TRIPDETL")}
          xVariant="contained"
          xDisabled={false}
          xSize="small"
        />
      ),
    },
    { field: "truckName", headerName: "TruckName", width: 130 },
    { field: "TripID", headerName: "TripID", width: 60, hide: true },
    { field: "TruckID", headerName: "TruckID", width: 60, hide: true },
    { field: "Status", headerName: "Status", width: 90 },
    { field: "EnBy", headerName: "EnBy", width: 60, hide: true },
    {
      field: "EnDt",
      headerName: "Start Date",
      width: 90,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "PostBy", headerName: "PostBy", width: 60, hide: true },
    {
      field: "PostDt",
      headerName: "End Date",
      width: 110,
      valueFormatter: ({ value }) =>
        moment(value).format("DD/MM/YYYY") == "Invalid date"
          ? ""
          : moment(value).format("DD/MM/YYYY"),
    },
  ]);

  const handleFetchData = async (
    startDate = Summary.startDate,
    endDate = Summary.endDate
  ) => {
    await fLoadTripsByDateRange(startDate, endDate, setRows);
  };
  const update = async (TripID) => {
    await fUpdateTripPostingStatus(TripID, handleFetchData);
  };

  useEffect(() => {
    handleFetchData(Summary.startDate, Summary.endDate);
  }, []);

  return (
    <Container>
      <div className="Breadcrumbs d-flex">
        {/* eslint-disable-next-line react/jsx-pascal-case */}
        <EasyLoading_Breadcrumbs />
      </div>
      <Grid
        container
        spacing={1}
        sx={{ margin: "5px 0px " }}
        columns={{ xs: 12, sm: 12, md: 12 }}
        alignItems={"center"}
      >
        <Grid item xs={6} sm={"auto"} md={"auto"}>
          <CmpDatePicker
            xLabelText={"From"}
            xValue={Summary.startDate}
            xOnChange={(newValue) =>
              setSummary((obj) => ({ ...obj, startDate: newValue.$d }))
            }
            xName={"dateFrom"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={6} sm={"auto"} md={"auto"}>
          <CmpDatePicker
            xLabelText={"To"}
            xValue={Summary.endDate}
            xOnChange={(newValue) =>
              setSummary((obj) => ({ ...obj, endDate: newValue.$d }))
            }
            xName={"endDate"}
            xError={false}
            xErrorMessage={false}
          />
        </Grid>
        <Grid item xs={12} sm={"auto"} md={"auto"} textAlign={"center"}>
          <CmpButton
            xbtnName="Load"
            xOnClick={() => {
              handleFetchData(Summary.startDate, Summary.endDate);
            }}
            xVariant="contained"
            xDisabled={false}
            xSize="small"
          />
        </Grid>
      </Grid>

      <Box sx={{ height: vMediaQuery ? "70vh" : "80vh", width: "100%" }}>
        <DataGrid
          rowHeight={30}
          headerHeight={40}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
          }}
          rows={rows}
          columns={columns}
          hideFooter={rows.length < 100}
          // components={{
          //   Toolbar: GridToolbar,
          // }}
        />
      </Box>
      <GCWebReport
        xfCloseWebReportModal={() => {
          setWebReportModal(false);
        }}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />
    </Container>
  );
};

export default TripDetailSummary;
